import React from 'react';
import {
  IconServer,
  IconCircleCheck,
  IconActivity
} from '@tabler/icons-react';

const NodeStatsCard = ({ nodes }) => {
  const stats = [
    {
      label: 'Всего нод',
      value: nodes.length,
      icon: IconServer,
      color: 'primary',
      bgColor: 'bg-primary-500/10',
      textColor: 'text-primary-500'
    },
    {
      label: 'Онлайн',
      value: nodes.filter(n => n.status === 'online').length,
      icon: IconCircleCheck,
      color: 'green',
      bgColor: 'bg-green-500/10',
      textColor: 'text-green-500'
    },
    {
      label: 'Активные туннели',
      value: nodes.reduce((sum, n) => sum + (n.active_tunnels || 0), 0),
      icon: IconActivity,
      color: 'purple',
      bgColor: 'bg-purple-500/10',
      textColor: 'text-purple-500'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
      {stats.map((stat, index) => (
        <div 
          key={index}
          className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-2xl p-5 hover:border-primary-500/30 transition-colors"
        >
          <div className="flex items-center">
            <div className={`w-12 h-12 ${stat.bgColor} rounded-xl flex items-center justify-center`}>
              <stat.icon className={`w-6 h-6 ${stat.textColor}`} />
            </div>
            <div className="ml-4">
              <p className="text-sm text-gray-600 dark:text-dark-400">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{stat.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NodeStatsCard;